'use client'
import { RadioProps, useRadio, cn, VisuallyHidden } from "@heroui/react";
import { motion } from "framer-motion";
import numeral from "numeral";

type PricingRadioProps = RadioProps &
  Partial<
    {
      time: string,
      pricing: string,
      unit: string,
      rebate: number,
      desc: string
    }>

export const PricingRadio = ({ time, pricing, unit, rebate, desc, ...props }: PricingRadioProps) => {

  const {
    Component,
    children,
    isSelected,
    getBaseProps,
    getInputProps,
    getLabelWrapperProps,
  } = useRadio(props);

  return (
    <Component
      {...getBaseProps()}
      className={cn(
        "group relative  bg-theme-primary/5 rounded-[12px] ",
        "text-center ring-[1px] overflow-hidden ring-theme-primary/10",
        "data-[selected=true]:ring-[3px] data-[selected=true]:ring-gradient-purple2",
        "transition-transform scale-100",
        "data-[selected=true]:bg-gradient-to-l from-gradient-purple2/15  to-gradient-blue2/15",
        "data-[pressed=true]:shadow-gradient-purple2/20 data-[pressed=true]:scale-[.98] sm:data-[pressed=true]:scale-95",
        "sm:data-[selected=true]:shadow-lg data-[selected=true]:shadow-gradient-purple2/20 sm:data-[selected=true]:translate-y-[-10px]",
        "max-w-[128px] w-[128px] flex-shrink-0 h-[148px]",
        "sm:max-w-[180px] sm:w-auto sm:flex-shrink sm:h-[210px] sm:flex-1"
      )}
    >
      <VisuallyHidden>
        <input {...getInputProps()} />
      </VisuallyHidden>
      <div className="relative h-full z-10 justify-between flex-col pt-4 sm:pt-8 pb-3 sm:pb-5 flex">
        <h3 className="text-theme-primary font-bold text-[14px] sm:text-[16px]">{time}</h3>
        <div className="font-bold">
          <h2 className="text-[24px] sm:text-[32px] leading-[1.2] sm:leading-[.8]">{pricing}</h2>
          <p className="text-[12px] sm:text-[16px]">{unit}</p>
          {
            rebate &&
            <motion.span
              animate={{
                scale: [1, 1.2, .9, 1],
              }}
              className={cn(
                "text-[12px] sm:text-[13px] font-normal mt-1 sm:mt-4 inline-block text-theme-white min-w-14 sm:min-w-16 rounded-full",
                "leading-5 sm:leading-6",
                "scale-90 sm:scale-100 origin-center",
                "bg-gradient-to-l from-gradient-purple2 to-gradient-blue2 "
              )}>
              {numeral(rebate).format('0%')}off
            </motion.span>
          }
        </div>
        <p className="text-[12px] text-theme-primary/70">{desc}</p>
      </div>

    </Component>
  )
}